import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { PTicketService } from '../../../services/p-ticket.service';
import { Router } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatOptionModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { NgFor, NgIf } from '@angular/common';
import { MatSelectModule } from '@angular/material/select';
import { MatDividerModule } from '@angular/material/divider';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatCardModule } from '@angular/material/card';
import { PhoneNumberComponent } from '../../generic/phone-number/phone-number.component';
import { MatRadioModule } from '@angular/material/radio';
import { Product } from '../../../interfaces/pProduct';
import { ProductService } from '../../../services/product.service';
import { MasterDataService } from '../../../services/master-data.service';
import {
  masterCountryCode,
  masterSupportLevel,
  masterTicketType,
} from '../../../interfaces/masterData';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import {
  MatAutocompleteModule,
  MatAutocompleteSelectedEvent,
} from '@angular/material/autocomplete';
import { pTicket } from '../../../interfaces/pTicket';
import { HttpParams } from '@angular/common/http';
import { debounceTime, filter, switchMap, tap } from 'rxjs';
import { MatStepper, MatStepperModule } from '@angular/material/stepper';
import { UploadFilesComponent } from '../../helpers/upload-files/upload-files.component';

@Component({
  selector: 'app-p-ticket-new',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatButtonModule,
    MatFormFieldModule,
    MatOptionModule,
    MatInputModule,
    MatSelectModule,
    MatDividerModule,
    MatCardModule,
    MatRadioModule,
    NgFor,
    NgIf,
    PhoneNumberComponent,
    MatDialogModule,
    MatAutocompleteModule,
    NgIf,
    MatStepperModule,
    UploadFilesComponent,
  ],
  templateUrl: './p-ticket-new.component.html',
  styleUrl: './p-ticket-new.component.scss',
})
export class PTicketNewComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private pTicketService: PTicketService,
    private masterDataService: MasterDataService,
    private pProductService: ProductService,

    private router: Router,
    private _snackBar: MatSnackBar,

    public dialogRef: MatDialogRef<PTicketNewComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { pct_tickettype: string },
  ) {}

  ticketTypes!: masterTicketType[];
  countryCodes!: masterCountryCode[];
  statuus: string[] = ['open', 'closed'];
  supportlevels!: masterSupportLevel[];
  send_mail: boolean = false;
  pProducts!: Product[];

  pTicketRecommendations: pTicket[] = [];
  isLoadingRecommendations: Boolean = false;

  companyRecommendations: pTicket[] = [];
  isLoadingCompanyRecommendations: boolean = false;

  isCreatingTicket: boolean = false;

  @ViewChild('stepper') stepper!: MatStepper;
  @ViewChild('fileUpload', { static: true }) fileUpload!: UploadFilesComponent;
  createpTicketForm = this.formBuilder.group({
    pct_countrycode: new FormControl('re', Validators.required),
    pct_useremail: new FormControl('', Validators.required),
    pct_user: new FormControl('', Validators.required),
    pct_company: new FormControl('', Validators.required),
    pct_product: new FormControl('', Validators.required),
    pct_initialdescription: new FormControl('', Validators.required),
    pct_callbacknumber: new FormControl('', Validators.required),
    pct_responsename: new FormControl('', Validators.required),
    pct_responseemail: new FormControl('', Validators.required),
    pct_supportlevel: new FormControl(1, Validators.required),
    pct_status: new FormControl('', Validators.required),
    pct_tickettype: new FormControl(
      this.data.pct_tickettype,
      Validators.required,
    ),
    pct_has_solution: new FormControl('false'),
    send_mail: new FormControl(''),
  });

  onSubmit(): void {
    if (this.createpTicketForm.valid) {
      this.isCreatingTicket = true;
      this.pTicketService.create(this.createpTicketForm.value).subscribe(
        (response) => {
          console.log(response);
          if (this.fileUpload.files.length > 0) {
            this.fileUpload.onFileUpload(response).subscribe((results) => {
              //this.openSnackBar("Ticket was successfully created", 2000);
              this.dialogRef.close();
              this.router.navigate([`/pTicket/${response.id}`]);
              this.isCreatingTicket = false;
            });
          } else {
            //this.openSnackBar("Ticket was successfully created", 2000);
            this.dialogRef.close();
            this.router.navigate([`/pTicket/${response.id}`]);
            this.isCreatingTicket = false;
          }
        },
        (error) => {
          this.openSnackBar(
            'Error while creating ticket \n' + error.message,
            5000,
          );
          this.isCreatingTicket = false;
        },
      );
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onNameSelected(event: MatAutocompleteSelectedEvent): void {
    this.createpTicketForm.patchValue({
      pct_user: event.option.value.pct_user,
      pct_company: event.option.value.pct_company,
      pct_responsename: event.option.value.pct_responsename,
      pct_responseemail: event.option.value.pct_responseemail,
      pct_useremail: event.option.value.pct_useremail,
      pct_callbacknumber: event.option.value.pct_callbacknumber,
      pct_countrycode: event.option.value.pct_countrycode,
    });
  }
  onCompanySelected(event: MatAutocompleteSelectedEvent): void {
    this.createpTicketForm.patchValue({
      pct_company: event.option.value.pct_company,
      pct_countrycode: event.option.value.pct_countrycode,
    });
  }

  ngOnInit() {
    this.masterDataService
      .getMasterCountrycodeMockList()
      .subscribe((countryCodes) => {
        this.countryCodes = countryCodes;
        this.createpTicketForm.patchValue({
          pct_countrycode: this.countryCodes[96].cod_alpha2,
          pct_status: 'open',
          pct_supportlevel: 1,
        });
      });
    this.masterDataService
      .getMasterTicketTypeList()
      .subscribe((ticketTypes) => (this.ticketTypes = ticketTypes));
    this.masterDataService
      .getMasterSupportLevelList()
      .subscribe((supportlevels) => (this.supportlevels = supportlevels));
    this.pProductService
      .getProducts()
      .subscribe((pProducts) => (this.pProducts = pProducts));
    this.createpTicketForm
      .get('pct_user')!
      .valueChanges.pipe(
        debounceTime(300),
        filter((val) => val !== null && val !== ''),
        tap(() => (this.isLoadingRecommendations = true)),
        switchMap((val) => {
          // Build HTTP params
          const start = new Date(2023, 0, 1);
          start.setHours(0, 0, 0, 0);
          const end = new Date();
          end.setHours(23, 59, 59, 999);

          const httpParams = new HttpParams()
            .append('updatedAt[$gte]', start.toISOString())
            .append('updatedAt[$lte]', end.toISOString())
            .append('pct_user', val || '');

          return this.pTicketService.getAll(httpParams);
        }),
      )
      .subscribe(({ data: pTicketList }) => {
        // Deduplicate & sort
        this.pTicketRecommendations = Array.from(
          pTicketList
            .reduce((map, ticket) => {
              const key = [
                ticket.pct_user?.trim(),
                ticket.pct_company?.trim(),
                ticket.pct_responsename?.trim(),
                ticket.pct_responseemail?.trim(),
                ticket.pct_useremail?.trim(),
                ticket.pct_callbacknumber?.trim(),
                ticket.pct_countrycode?.trim(),
              ].join('|');
              if (!map.has(key)) map.set(key, ticket);
              return map;
            }, new Map<string, pTicket>())
            .values(),
        ).sort((a, b) => a.pct_user.localeCompare(b.pct_user));

        this.isLoadingRecommendations = false;
      });
    this.createpTicketForm
      .get('pct_company')!
      .valueChanges.pipe(
        debounceTime(300),
        filter((val) => val !== null && val !== ''),
        tap(() => (this.isLoadingCompanyRecommendations = true)),
        switchMap((val) => {
          const start = new Date(2023, 0, 1);
          start.setHours(0, 0, 0, 0);
          const end = new Date();
          end.setHours(23, 59, 59, 59);
          const httpParams = new HttpParams()
            .append('updatedAt[$gte]', start.toISOString())
            .append('updatedAt[$lte]', end.toISOString())
            .append('pct_company', val || '');
          return this.pTicketService.getAll(httpParams);
        }),
      )
      .subscribe(({ data: pTicketList }) => {
        this.companyRecommendations = Array.from(
          pTicketList
            .reduce((map, ticket) => {
              const key = [
                ticket.pct_company?.trim(),
                ticket.pct_countrycode?.trim(),
              ].join('|');
              if (!map.has(key)) map.set(key, ticket);
              return map;
            }, new Map<string, pTicket>())
            .values(),
        ).sort((a, b) => a.pct_company.localeCompare(b.pct_company));

        this.isLoadingCompanyRecommendations = false;
      });
  }

  ngAfterViewInit(): void {
    this.stepper.selectedIndex = 1;
  }

  openSnackBar(message: string, duration: number) {
    this._snackBar.open(message, 'Dismiss', { duration: 2000 });
  }

  isLinear = false;
}
